"use client";

import { SafeHydrate } from "@/SafeHydrate";
import * as React from "react";
import { Star } from "lucide-react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const testimonials = [{
  quote: "Stuck on the M62 with a flat. They arrived in 35 minutes and had me back on the road. Lifesavers!",
  author: "James W. - Pudsey",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1647150/img/leeds_driver_james.png"
}, {
  quote: "Best mobile tyre fitting Leeds has to offer. Professional, fast, and very reasonably priced.",
  author: "Sarah L. - Headingley",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1647150/img/leeds_driver_sarah.png"
}, {
  quote: "24/7 service that actually answers the phone! Emergency puncture repair done right at my driveway.",
  author: "David R. - Morley",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1647150/img/leeds_driver_david.png"
}];
export default function RealStoriesFromSatisfiedUsers() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="221991" id="leeds-driver-feedback" className="bg-background text-foreground py-24 md:py-32 overflow-hidden bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-primary/10 via-background to-background">
      <div ref={ref} className={`container mx-auto px-4 md:px-6 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <div className="flex flex-col items-center text-center mb-16 space-y-4">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold font-default tracking-tighter uppercase text-foreground">
            Leeds Driver Feedback
          </h2>
          <div className="h-1.5 w-24 bg-primary rounded-full shadow-[0_0_15px_rgba(249,115,22,0.5)]"></div>
        </div>

        <div className="max-w-4xl mx-auto px-12 md:px-16 relative">
          <Carousel opts={{
          align: "start",
          loop: true
        }} className="w-full">
            <CarouselContent>
              {testimonials.map((testimonial, index) => <CarouselItem key={index} data-index={index}>
                  <div className="flex flex-col items-center text-center space-y-8 py-8">
                    <div className="flex gap-1.5">
                      {[...Array(5)].map((_, starIndex) => <Star key={starIndex} data-index={starIndex} className="size-6 fill-primary text-primary drop-shadow-[0_0_8px_rgba(249,115,22,0.4)]" />)}
                    </div>
                    
                    <blockquote className="text-2xl md:text-3xl font-bold font-default leading-snug text-foreground max-w-3xl italic">
                      "{testimonial.quote}"
                    </blockquote>
                    
                    <div className="flex items-center gap-4 mt-4">
                      <SafeHydrate><Avatar className="size-14 border-2 border-primary/30 shadow-lg">
                        <AvatarImage src={testimonial.avatar} alt={testimonial.author} className="object-cover" />
                        <AvatarFallback className="bg-secondary text-primary font-default font-bold">
                          {testimonial.author.charAt(0)}
                        </AvatarFallback>
                      </Avatar></SafeHydrate>
                      <div className="text-left flex flex-col">
                        <span className="font-bold font-default text-foreground text-lg">
                          {testimonial.author}
                        </span>
                        <span className="text-sm text-primary font-mono uppercase tracking-wider">
                          Verified Local
                        </span>
                      </div>
                    </div>
                  </div>
                </CarouselItem>)}
            </CarouselContent>
            <CarouselPrevious className="hidden md:flex -left-4 md:-left-12 size-12 border-border bg-card/50 backdrop-blur-sm hover:bg-primary hover:text-primary-foreground transition-all duration-300" />
            <CarouselNext className="hidden md:flex -right-4 md:-right-12 size-12 border-border bg-card/50 backdrop-blur-sm hover:bg-primary hover:text-primary-foreground transition-all duration-300" />
            
            {}
            <div className="flex justify-center gap-4 mt-8 md:hidden">
              <CarouselPrevious className="static translate-x-0 translate-y-0 size-10 bg-card border-border" />
              <CarouselNext className="static translate-x-0 translate-y-0 size-10 bg-card border-border" />
            </div>
          </Carousel>
        </div>
      </div>
    </section>;
}